import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getClassroomPdf } from "../../../api/general";

const Bar = () => {
  const { setAddClassroomClick, setClassroomInputValue,classroomInputValue } =
    useContext(StoreContext);

  const getClassroomPdfMethod = async () => {
    const response = await getClassroomPdf();
    if (response.error) {
      console.log("Sınıf pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Sınıf pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.classrooms}>
        <div className={style.classroomstext}>Sınıflar</div>
        <Link>
          <img alt="" className={style.classroomsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setClassroomInputValue(e.target.value);
          }}
          value={classroomInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddClassroomClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Sınıf</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
            //  getClassroomPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
